var styles = {"title":"CommonHeaderTitle-module_title__rAE2j","has-tooltip":"CommonHeaderTitle-module_has-tooltip__Gkj9e","button-tooltip":"CommonHeaderTitle-module_button-tooltip__gtwSV"};

export { styles as default };
